<template>
  <div class="page page--login">
    <div class="login-wrapper">
      <div class="login-left">
        <div class="login__logo">
          <img src="@/assets/img/amway_logo_white.svg" alt="Amway" />
        </div>
        <div class="login__text">
          <h1 class="login__title">Конструктор<br />Личной страницы</h1>
          <p class="login__subtitle">
            Создай свою личную страницу в 3 простых шага. Расскажи о себе, о
            своих товарах, личных достижениях. Поделись страницей с клиентами, и
            привлеки новых.
          </p>
        </div>
        <div class="login__buttons">
          <button class="login__btn login__btn--primary" @click="ssoLogin">
            <span>Войти с Amway ID</span>
          </button>
          <button
            class="login__btn login__btn--secondary"
            @click="
              () => {
                $router.push('/support');
                this.GAEvent('main-support_click');
              }
            "
          >
            <span>Поддержка</span>
          </button>
        </div>
      </div>
      <div class="login-right">
        <div class="login__image_wrapper">
          <img
            src="@/assets/img/login-right-image.svg"
            alt="Как создать личную страницу"
          />
        </div>
        <!--<div class="login__right__button" @click="()=>{showVideo(); this.GAEvent('main-training_video_click')}">
          <img
            src="@/assets/img/play-button.svg"
            alt="Как создать личную страницу"
          />
          <span>Как создать личную страницу</span>
        </div>-->
      </div>
    </div>
    <ui-modal ref="videoModal" @close="$refs.video.pause()">
      <h2 class="video_header" slot="header">Обучающее видео</h2>
      <video
        ref="video"
        src="https://amwaypersonalpage.ru/media/PRW-intro-video.0062cab6.mp4"
        controls
        preload="auto"
      ></video>
    </ui-modal>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { UiTextbox, UiButton, UiCheckbox } from "keen-ui";
import { AsYouType } from "libphonenumber-js";

export default {
  components: {
    UiTextbox,
    UiButton,
    UiCheckbox
  },
  data() {
    return {
      username: null,
      password: null,
      dev: process.env.VUE_APP_FORCE_DEV,
      rememberPassword: true,
      support_modal: {
        first_lastname: "",
        abo_number: "",
        email: "",
        phone: "",
        message_text: "",
        file: null
      }
    };
  },
  computed: {
    ...mapState(["login"])
  },
  methods: {
    ...mapActions(["loginAction"]),
    processFiles(e) {
      this.support_modal.file = e.target.files[0];
      this.$refs.supportFileName.innerText = this.support_modal.file.name;
    },
    formatPhone() {
      this.support_modal.phone = new AsYouType("RU").input(
        this.support_modal.phone
      );
    },
    showVideo() {
      this.$refs.videoModal.open();
      this.$refs.video.play();
    },

    tryLogin() {
      const data = {
        login: this.username,
        password: this.password,
        rememberPassword: this.rememberPassword
      };
      const formdata = new FormData();
      for (let key in data) {
        formdata.append(key, data[key]);
      }
      this.loginAction(formdata);
    },
    ssoLogin() {
      this.GAEvent("main-login_with_amway_id");
      let url = new URL(process.env.VUE_APP_SSO_HOST);
      let data = {
        client_id: window.location.host.match(/^kz/)
          ? process.env.VUE_APP_SSO_CLIENT_ID_KZ
          : process.env.VUE_APP_SSO_CLIENT_ID_RU,
        redirect_uri: `${window.location.protocol}//${window.location.host}${process.env.VUE_APP_SSO_REDIRECT_URL}`,
        clientapp: "amwaypersonalpages",
        response_type: "id_token",
        state: "WAHWBTaLbBetB}K0fpcgr$VGgVOA7$bJzquy73CE",
        nonce: "Bi58Q#VUywDFsu",
        scope:
          "openid partyID abo acct_subtype abo_name sponsor",
        amw_clientapp: "amwaypersonalpages",
        amw_lng: "ru-ru"
      };
      url.search = new URLSearchParams(data);
      if (process.env.VUE_APP_FORCE_DEV) {
        console.log(url.toString());
      }
      console.log(url.toString());
      return (window.location.href = url.toString());
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";

/deep/ .ui-textbox.is-invalid:not(.is-disabled) .ui-textbox__feedback {
  color: #e91e4e;
}

/deep/ .ui-textbox.is-invalid:not(.is-disabled) .ui-textbox__label-text,
.ui-textbox.is-invalid:not(.is-disabled) .ui-textbox__icon-wrapper .ui-icon,
.ui-textbox.is-invalid:not(.is-disabled) .ui-textbox__counter {
  color: #e91e4e;
}

video {
  @media #{$tablet} {
    width: 100%;
  }
}

.page--login {
  display: flex;
  justify-content: start;
  flex-direction: row;
  padding: 0;
  * {
    font-family: "Inter", sans-serif !important;
  }
}

.login__btn {
  outline: none;
  border-radius: 5px;
  width: 240px;
  padding: 17px 0 16px;
  font-size: 18px;
  text-transform: uppercase;
  cursor: pointer;
  position: relative;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out;
  will-change: color;
  @media #{$mobile} {
    width: 100%;
  }

  span {
    z-index: 1;
    position: relative;
  }

  &--primary {
    background: #ffffff;
    color: #000000;
    border: 1px solid transparent;

    &:hover {
      color: #ffffff;
    }

    &:before {
      background: #584dc2;
    }

    &:before {
      content: "";
      width: calc(100% + 2px);
      max-width: 0;
      height: calc(100% + 2px);
      position: absolute;
      top: -1px;
      left: -1px;
      transition: max-width 0.3s ease-in-out;
      will-change: max-width;
      border-radius: 5px;
      z-index: 0;
    }

    &:hover:before {
      max-width: calc(100% + 2px);
    }
  }

  &--secondary {
    background: transparent;
    color: #ffffff;
    border: 1px solid #ffffff;
    &:hover {
      border-color: #e0e0e0;
      color: #e0e0e0;
    }
  }
}

.login {
  &-wrapper {
    display: flex;
    flex-basis: 100%;
    @media #{$tablet} {
      flex-direction: column;
    }
  }

  &__logo {
    img {
      max-width: 156px;
      @media #{$mobile} {
        max-width: 100px;
      }
    }
  }

  &-left {
    background: $new-blue;
    flex-basis: 50%;
    padding: 150px 20px 150px 150px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    @media (max-width: 1440px) {
      padding-left: 80px;
      padding-right: 45px;
    }
    @media (max-width: 1024px) {
      padding: 60px 30px 80px;
      flex-basis: 60%;
    }
    @media #{$mobile} {
      padding: 25px 15px;
      flex-basis: 500px;
    }
  }

  &-right {
    flex-basis: 50%;
    padding: 150px 0 150px;
    background: #cce3ff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media #{$tablet} {
      flex-basis: 40%;
      padding: 40px 50px;
      flex-direction: row;
    }
  }

  &__text {
    display: flex;
    flex-direction: column;
  }

  &__title {
    font-size: 64px;
    font-weight: bold;
    margin: 0 0 35px;
    line-height: 120%;
    max-width: 100%;
    color: #ffffff;
    text-align: left;
    @media (max-width: 1366px) {
      font-size: 48px;
    }
    @media #{$mobile} {
      font-size: 32px;
    }
  }

  &__subtitle {
    font-size: 16px;
    max-width: 400px;
    line-height: 140%;
    color: #ffffff;
  }

  &__buttons {
    display: flex;

    & > *:not(:last-child) {
      margin-right: 25px;
      @media #{$mobile} {
        margin-right: 0;
        margin-bottom: 15px;
      }
    }

    @media #{$mobile} {
      flex-direction: column;
    }
  }

  &__right__button {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    & > img {
      margin-right: 25px;
      @media #{$tablet} {
        max-width: 58px;
      }
    }

    & > span {
      font-size: 34px;
      max-width: 300px;
      @media #{$tablet} {
        font-size: 22px;
      }
    }
  }

  &__image_wrapper {
    img {
      @media (max-width: 1440px) {
        max-width: 450px;
      }
      @media (max-width: 1366px) {
        max-width: 400px;
      }
      @media (max-width: 1024px) {
        max-width: 300px;
      }
      @media #{$tablet} {
        max-width: 355px;
        margin-right: 35px;
      }
      @media #{$mobile} {
        max-width: 215px;
      }
    }
  }
}

.entry {
  z-index: 10000;
  height: 70vh;
  margin-bottom: 20px;
  @media all and (max-height: 800px) {
    height: 70%;
  }

  /deep/ .ui-textbox__feedback {
    position: absolute;
  }
}

.modal-content {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
  @media #{$tablet} {
    flex-flow: column nowrap;
    align-items: center;
    & > .col:nth-child(3) {
      transform: translateX(-16px);

      & > *:nth-child(3) ~ * {
        transform: translateX(20px);
      }
    }
  }
}

.col {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 0 0 calc(50% - 20px);
}

.modal-footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 20px;

  button {
    margin: 0 10px;
  }
}

/deep/ .open-modal-support {
  text-align: center;
}

.ui-modal__mask {
  z-index: 10001;
}

.video_header {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  font-size: 24px;
  padding: 28px 15px 20px 15px;
  margin: 0;
}

.form-support {
  width: 100%;
}

.disclaimer {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  text-align: left;
}

.support-upload {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  input[type="file"] {
    display: none;
  }
}

.support-input-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 15px;
  margin-bottom: 20px;
  cursor: pointer;

  span {
    &:first-child {
      font-weight: 800;
      font-size: 14px;
      line-height: 1.5;
      color: #000000;
    }

    &:last-child {
      color: rgba(0, 0, 0, 0.5);
    }
  }
}

.sso-login {
  color: #4caf50;
  width: 100%;
  height: 108px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>
